import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect, useState } from 'react';
import { Alert, Badge, Col, Container, Image, Row } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import FollowButton from './FollowButton';

const Creators = () => {
    async function getCertificationUserList(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/profile/certificationUserList/").then((r)=>r.json().then((d)=>{
            return d
        }))
    }

    const location = useLocation()
	const [certificationUserList,setCertificationUserList] = useState([])

	useEffect(() => {
		document.querySelector("title").textContent = "公認クリエイター一覧 - 「アワートAI」AIイラスト投稿サイト。AI自動生成も無料。"
		getCertificationUserList().then(r=>{
			if(r.result){
				setCertificationUserList(r.data)
			}
		})
	},[location.pathname])

    return(
    <div className="wrapper">
        <header className="App-header"></header>
        <Header />
        <Category />
        <Container className='mt-4 mb-3' style={{fontSize:"18px",fontWeight:"bold",display:"block",borderLeft:"10px solid lightblue",borderBottom:"3px solid lightblue"}}>
            <Icon.ShieldFillCheck style={{paddingBottom:"1px",color:"green"}} /> 公認クリエイター一覧<br />
        </Container>
        <Container className='w-100 mb-3' style={{display:"block"}}>
            <Row>
            {certificationUserList.map((data,i) => {
            return <Col xs={5} sm={5} md={3} lg={2} xl={2} xxl={2} style={{margin:"0 auto",textAlign:"center",fontWeight:"bold"}} key={i} className='p-3'>
                        <Link to={"/user/"+(data.user_id)}><Image src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+"/profile/"+data.user_id+".jpg"} style={{width:"100%",height:"auto",borderRadius:"50%"}} /></Link>
                        <LinkContainer to={"/user/"+(data.user_id)} style={{color:"#555555",textDecoration:"none",cursor:"pointer"}}><span>{data.user_name}</span></LinkContainer><br />
                        <FollowButton userId={data.user_id} follow={data.follow} />
                </Col>
            })}
            </Row>
        </Container>
        <Footer />
    </div>
    )
}

export default Creators;
